import { fullstoryEvent } from './fullstory-event';
import { pickBy } from 'lodash-es';

interface CalculatorClosedProps {
  engagement_location: string;
  changed_age: boolean;
  changed_credit: boolean;
  changed_miles: boolean;
  changed_months: boolean;
  min_savings: number | undefined;
  max_savings: number | undefined;
}

function isDefined(value: boolean | number | string | undefined) {
  return value !== undefined;
}

export function fullstoryCalculatorClosedEvent(props: CalculatorClosedProps) {
  fullstoryEvent('savings_calculator_closed', {
    ...pickBy(props, isDefined),
  });
}
